/**
 * The one hyperlink recipe — docs/009-ui-design-guidelines.md, "Links".
 *
 * `TextLink` and `BackLink` both spread this, so the two can never drift apart:
 * the accent colour (`text-brand`, which follows the user-selected palette),
 * the underline-on-hover affordance, the shared focus ring, and the
 * `aria-disabled` treatment. There is deliberately NO visited colour — a console
 * link is navigation inside an app, not a document reference.
 *
 * Not exported from the package: an app that needs a link renders one of the
 * two components. Borrowing the classes is exactly the hand-rolling the
 * `NO_RAW_LINK_ELEMENT` / `NO_HAND_ROLLED_LINK_CLASSNAME` lint rules forbid.
 */
export const LINK_CLASSES = [
    "text-brand underline-offset-4 hover:underline",
    "focus-visible:outline-none focus-visible:shadow-focus",
    "aria-disabled:pointer-events-none aria-disabled:opacity-50",
].join(" ");
//# sourceMappingURL=link-classes.js.map